const normalizeSearchTerm = value =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLocaleLowerCase();

const INBOX_GROUPS = [
  { key: 'whatsapp', label: 'WhatsApp', icon: 'i-ri-whatsapp-fill' },
  { key: 'instagram', label: 'Instagram', icon: 'i-ri-instagram-fill' },
  { key: 'messenger', label: 'Messenger', icon: 'i-ri-messenger-fill' },
  { key: 'telegram', label: 'Telegram', icon: 'i-ri-telegram-fill' },
  { key: 'email', label: 'E-mail', icon: 'i-lucide-mail' },
  { key: 'website', label: 'Site', icon: 'i-lucide-globe-2' },
  { key: 'api', label: 'API', icon: 'i-lucide-cloud' },
  { key: 'sms', label: 'SMS', icon: 'i-lucide-message-square' },
  { key: 'other', label: 'Outras conexões', icon: 'i-lucide-layout-grid' },
];

const inboxGroupKey = inbox => {
  const channelType = inbox.channel_type;
  const medium = inbox.medium || inbox.phone_number?.startsWith('whatsapp');
  const isEvolutionApi =
    inbox.additional_attributes?.is_evolution_api_integration;

  if (
    channelType === 'Channel::Whatsapp' ||
    isEvolutionApi ||
    (channelType === 'Channel::TwilioSms' &&
      (medium === 'whatsapp' || medium === true))
  ) {
    return 'whatsapp';
  }

  return (
    {
      'Channel::Instagram': 'instagram',
      'Channel::FacebookPage': 'messenger',
      'Channel::Telegram': 'telegram',
      'Channel::Email': 'email',
      'Channel::WebWidget': 'website',
      'Channel::Api': 'api',
      'Channel::Sms': 'sms',
      'Channel::TwilioSms': 'sms',
    }[channelType] || 'other'
  );
};

export const filterAndSortConversationFilters = (items, query, getLabel) => {
  const normalizedQuery = normalizeSearchTerm(query);

  return [...items]
    .filter(item =>
      normalizeSearchTerm(getLabel(item)).includes(normalizedQuery)
    )
    .sort((first, second) =>
      String(getLabel(first)).localeCompare(
        String(getLabel(second)),
        undefined,
        {
          sensitivity: 'base',
        }
      )
    );
};

export const groupConversationInboxes = inboxes => {
  const groupedInboxes = inboxes.reduce((groups, inbox) => {
    const key = inboxGroupKey(inbox);
    groups[key] = [...(groups[key] || []), inbox];
    return groups;
  }, {});

  return INBOX_GROUPS.filter(group => groupedInboxes[group.key]?.length).map(
    group => ({ ...group, items: groupedInboxes[group.key] })
  );
};
